









import { mapActions, mapState } from 'vuex'
import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'
import { VBtn, VIcon, VTextField, VList, VListItem, VListItemTitle } from 'vuetify/lib'
import { Prop } from 'vue-property-decorator'

@Component({
  components: { VBtn, VIcon, VTextField, VList, VListItem, VListItemTitle },
  methods: { ...mapActions(['getRandom']) }
})
export default class StringList extends Vue {
  getRandom!: (params: { query: string; tags?: string[]}) => Promise<string>;

  @Prop({ type: String, required: false })
  private hint?: string;

  @Prop({ type: String, required: false })
  private randomTag?: string;

  @Prop({ type: Array as PropType<string[]>, default: () => [] })
  private value!: string[];

  async addEntry () {
    let res: string
    if (this.randomTag) {
      const params = { query: this.randomTag }
      console.log('randomValue: ', params)
      res = await this.getRandom(params)
    } else {
      res = ''
    }
    this.value.splice(this.value.length, 0, res)
  }

  async randomValue (index: number) {
    let res: string
    if (this.randomTag) {
      const params = { query: this.randomTag }
      console.log('randomValue: ', params)
      res = await this.getRandom(params)
    } else {
      res = ''
    }
    this.value.splice(index, 1, res)
  }
}
